import React, { useState } from "react";
import {
  Tooltip,
  tooltipClasses,
  styled,
  Typography,
  IconButton,
} from "@mui/material";

const SpeechTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    PopperProps={{
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [130, -7], // tooltip box left/right shift
          },
        },
      ],
    }}
  />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 1)",
    borderRadius: "12px",
    maxWidth: 339,
    fontSize: "12px",
    fontWeight: 400,
    boxShadow: "3px 8px 24px rgba(255, 89, 89, 0.1)",
    // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    padding: "10px 14px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#fff",
    "&:before": {
        width: "5px",
        height: "15px",
    },
  },
}));

export default function CustomTooltip({name_mismatch_error}) {
  const [open, setOpen] = useState(false);

  return (
    <SpeechTooltip
      arrow
      placement="top"
      open={open}
      onClose={() => setOpen(false)}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      title={
        <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
          {name_mismatch_error}
        </Typography>
      }
    >
      <IconButton onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} sx={{ p: "0", }}>
        <img src={`${process.env.PUBLIC_URL}/images/info_icon.svg`} alt="infoIcon" style={{ width: 18, height: 18 }} />
      </IconButton>
    </SpeechTooltip>
  );
}
